export enum CoactiviteDecision {
	AUTHORIZE = "authorize",
	AUTHORIZE_WITH_FORCE = "autorize_with_force",
	DENY = "deny",
	CANCEL = "cancel",	
	ASK_VALIDATION = "ask_validation",
}